export enum ActionTypesEnum {
  APP_GET_USER = 'APP_GET_USER',
  APP_SHOW_NOTIFICATION = 'APP_SHOW_NOTIFICATION',
  APP_HIDE_NOTIFICATION = 'APP_HIDE_NOTIFICATION',
  APP_CLEAR_CANVAS_EFFECT = 'APP_CLEAR_CANVAS_EFFECT'
}
